import { i18n } from 'i18n';
import { EStatuses, TLabelValue } from 'shared/typings';

export const STATUSES = {
	[EStatuses.AWAIT_VERIFICATION]: i18n.t('Awaiting verification'),
	[EStatuses.DRAFT]: i18n.t('Draft'),
	[EStatuses.IN_PROGRESS]: i18n.t('In progress'),
	[EStatuses.PUBLISHED]: i18n.t('Published'),
	[EStatuses.VERIFIED]: i18n.t('Verified'),
};

export const STATUSES_OPTIONS: TLabelValue[] = Object.entries(STATUSES).map(([key, value]) => ({
	value: key,
	label: value,
}));
